import { useEffect, useRef, useState } from "react";
import { isEnableChat, isEnableFeed } from "shared/pages/teams/const/ModerationTypes";
import { API, Lang } from "@brg/api";
import { useTranslation } from "react-i18next";
import urlApi from "shared/actions/urlApi";
import { useProfile } from "@brg/auth";
import { convertJsonToString } from "../helpers/convertJsonToString";

const getPrefix = (lang: string) => {
    if (lang === 'ru') {
        return {
            coursePrefix: 'Программа: ',
            groupPrefix: 'Группа: '
        }
    }
    else {
        return {
            coursePrefix: 'Programm: ',
            groupPrefix: 'Group: '
        }
    }
}

export const useTeamMetaData = (team: any, disable?: boolean)  => {
    const {i18n:{language}} = useTranslation();
    const profile = useProfile();
    const loadedTeamIdRef = useRef<string | undefined>(undefined);
    const [isMetaReady, setIsMetaReady] = useState(false);
    const [dataSync, setDataSync] = useState({
        courseName: '',
        groupName: '',
        groupTitle: '',
        coursePrefix: '',
        format: '',
        type: '',
        groupPrefix: '',
        channelLink: '',
        subscribers: '',
        feedLink: '',
        chatLink: '',
        enableFeed: false,
        enableChat: false,
        enableSubscribe: false,
    })

    const [dataAsync, setDataAsync] = useState({   
        ownersChannels: [] as any[],  
        tags: [] as any[]
    })

    useEffect(() => {
        if (!team || disable) {
            loadedTeamIdRef.current = undefined;
            setIsMetaReady(false);
            return;
        }

        let cancelled = false;
        setIsMetaReady(false);

        void (async () => {
            const {
                lmsCourseId,
                lmsCourseName,
                lmsCourseRoute,
                lmsGroupName,
                lmsCourseType,
                lmsCourseModuleFormat,
                lmsGroupTitle
            } = team?.additionalInfo ?? {};
            const { subscribersCount, mainFilter, teamId } = team;
            const { ownerTagIds } = mainFilter || {};

            const enableFeed = isEnableFeed(team, profile);
            const enableChat = isEnableChat(team, profile);
            // const enableSubscribe = team?.isCanSubscribe ?? false;
            const enableSubscribe = enableFeed
            const parseLmsName = convertJsonToString(lmsCourseName);
            const parseGroupName = convertJsonToString(lmsGroupName);
            const parseGroupTitleName = convertJsonToString(lmsGroupTitle);
            const format = convertJsonToString(lmsCourseModuleFormat);
            const type = lmsCourseType ? lmsCourseType : '';
            const translatedLmsName = Lang(parseLmsName, language) || '';
            const translatedGroupName = Lang(parseGroupName, language) || '';
            const translatedGroupTitleName = Lang(parseGroupTitleName, language) || '';
            const lmsRoute = lmsCourseRoute || process.env.REACT_APP_URL_HSEDESIGN_LMS + '/teams/' + lmsCourseId;
            const feedLink = enableFeed ? window.location.origin + '/teams/' + teamId + '/feed' : '';
            const chatLink = team?.enableChat ? window.location.origin + '/teams/' + teamId + '/chat' : '';
            const subscribers = subscribersCount > 0 ? subscribersCount : '0';

            setDataSync({
                courseName: translatedLmsName,
                groupName: translatedGroupName,
                groupTitle: translatedGroupTitleName,
                channelLink: lmsRoute,
                format,
                type,
                subscribers,
                feedLink,
                chatLink,
                enableFeed,
                enableChat,
                enableSubscribe,
                ...getPrefix(language)
            });

            let tagsList: any[] = [];
            let ownersChannels: any[] = [];
            try {
                tagsList = ownerTagIds?.length ? await urlApi()?.fetchTags(ownerTagIds) : [];
            } catch {
                tagsList = [];
            }
            try {
                ownersChannels = team?.owners?.[0] ? await urlApi()?.fetchOwnerChannels(team?.owners?.[0]?.designerId) : [];
            } catch {
                ownersChannels = [];
            }

            if (cancelled) {
                return;
            }

            setDataAsync({
                ownersChannels,
                tags: API.toLang(tagsList, language),
            })
           
            loadedTeamIdRef.current = teamId;
            setIsMetaReady(true);
        })();

        return () => {
            cancelled = true;
        };
    }, [team?.teamId, disable, language, profile]);

    if (!team || disable || !isMetaReady || loadedTeamIdRef.current !== team.teamId) {
        return {
            data: null,
            dataSync,
            loading: !disable
        };
    }

    return {
        data: {
            ...dataAsync,
            ...dataSync
        },
        dataSync,
        loading: false
    };
}import { useEffect, useRef, useState } from "react";
import { isEnableChat, isEnableFeed } from "shared/pages/teams/const/ModerationTypes";
import { API, Lang } from "@brg/api";
import { useTranslation } from "react-i18next";
import urlApi from "shared/actions/urlApi";
import { useProfile } from "@brg/auth";
import { convertJsonToString } from "../helpers/convertJsonToString";

const getPrefix = (lang: string) => {
    if (lang === 'ru') {
        return {
            coursePrefix: 'Программа: ',
            groupPrefix: 'Группа: '
        }
    }
    else {
        return {
            coursePrefix: 'Programm: ',
            groupPrefix: 'Group: '
        }
    }
}

export const useTeamMetaData = (team: any, disable?: boolean)  => {
    const {i18n:{language}} = useTranslation();
    const profile = useProfile();
    const loadedTeamIdRef = useRef<string | undefined>(undefined);
    const [isMetaReady, setIsMetaReady] = useState(false);
    const [dataSync, setDataSync] = useState({
        courseName: '',
        groupName: '',
        groupTitle: '',
        coursePrefix: '',
        format: '',
        type: '',
        groupPrefix: '',
        channelLink: '',
        subscribers: '',
        feedLink: '',
        chatLink: '',
        enableFeed: false,
        enableChat: false,
        enableSubscribe: false,
    })

    const [dataAsync, setDataAsync] = useState({   
        ownersChannels: [] as any[],  
        tags: [] as any[]
    })

    useEffect(() => {
        if (!team || disable) {
            loadedTeamIdRef.current = undefined;
            setIsMetaReady(false);
            return;
        }

        let cancelled = false;
        setIsMetaReady(false);

        void (async () => {
            const {
                lmsCourseId,
                lmsCourseName,
                lmsCourseRoute,
                lmsGroupName,
                lmsCourseType,
                lmsCourseModuleFormat,
                lmsGroupTitle
            } = team?.additionalInfo ?? {};
            const { subscribersCount, mainFilter, teamId } = team;
            const { ownerTagIds } = mainFilter || {};

            const enableFeed = isEnableFeed(team, profile);
            const enableChat = isEnableChat(team, profile);
            // const enableSubscribe = team?.isCanSubscribe ?? false;
            const enableSubscribe = enableFeed
            const parseLmsName = convertJsonToString(lmsCourseName);
            const parseGroupName = convertJsonToString(lmsGroupName);
            const parseGroupTitleName = convertJsonToString(lmsGroupTitle);
            const format = convertJsonToString(lmsCourseModuleFormat);
            const type = lmsCourseType ? lmsCourseType : '';
            const translatedLmsName = Lang(parseLmsName, language) || '';
            const translatedGroupName = Lang(parseGroupName, language) || '';
            const translatedGroupTitleName = Lang(parseGroupTitleName, language) || '';
            const lmsRoute = lmsCourseRoute || process.env.REACT_APP_URL_HSEDESIGN_LMS + '/teams/' + lmsCourseId;
            const feedLink = enableFeed ? window.location.origin + '/teams/' + teamId + '/feed' : '';
            const chatLink = team?.enableChat ? window.location.origin + '/teams/' + teamId + '/chat' : '';
            const subscribers = subscribersCount > 0 ? subscribersCount : '0';

            setDataSync({
                courseName: translatedLmsName,
                groupName: translatedGroupName,
                groupTitle: translatedGroupTitleName,
                channelLink: lmsRoute,
                format,
                type,
                subscribers,
                feedLink,
                chatLink,
                enableFeed,
                enableChat,
                enableSubscribe,
                ...getPrefix(language)
            });

            let tagsList: any[] = [];
            let ownersChannels: any[] = [];
            try {
                tagsList = ownerTagIds?.length ? await urlApi()?.fetchTags(ownerTagIds) : [];
            } catch {
                tagsList = [];
            }
            try {
                ownersChannels = team?.owners?.[0] ? await urlApi()?.fetchOwnerChannels(team?.owners?.[0]?.designerId) : [];
            } catch {
                ownersChannels = [];
            }

            if (cancelled) {
                return;
            }

            setDataAsync({
                ownersChannels,
                tags: API.toLang(tagsList, language),
            })
           
            loadedTeamIdRef.current = teamId;
            setIsMetaReady(true);
        })();

        return () => {
            cancelled = true;
        };
    }, [team?.teamId, disable, language, profile]);

    if (!team || disable || !isMetaReady || loadedTeamIdRef.current !== team.teamId) {
        return {
            data: null,
            dataSync,
            loading: !disable
        };
    }

    return {
        data: {
            ...dataAsync,
            ...dataSync
        },
        dataSync,
        loading: false
    };
}